const LAST_PHARMACY_ID_KEY = 'last_pharmacy_id';

export const pharmacyStorage = {
  getLastPharmacyId: (): string | null => {
    return localStorage.getItem(LAST_PHARMACY_ID_KEY);
  },
  setLastPharmacyId: (pharmacyId: string): void => {
    localStorage.setItem(LAST_PHARMACY_ID_KEY, pharmacyId);
  },
  clearLastPharmacyId: (): void => {
    localStorage.removeItem(LAST_PHARMACY_ID_KEY);
  },
};
